import { Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../atoms/Button';

function BenefitOrderButtons({
  onSave,
  onSend,
  benefitOrder,
  onDownloadDetailReport,
  onApplyValuesToAll,
  onRequestReopening,
}) {
  return (
    <Col
      style={{
        display: 'grid',
        gridAutoFlow: 'column',
        columnGap: 16,
        marginLeft: 'auto',
        justifyContent: 'flex-end',
      }}
    >
      {benefitOrder.isEditable && <Button onClick={onApplyValuesToAll}>Aplicar valores a todos</Button>}
      <Button onClick={onDownloadDetailReport}>Gerar Relatório</Button>
      {benefitOrder.isEditable && <Button onClick={onSave}>Salvar Rascunho</Button>}
      {benefitOrder.canRequestReopening && (
        <Button
          onClick={onRequestReopening}
          type="primary"
        >
          Alterar período/Reabrir
        </Button>
      )}
      {benefitOrder.isEditable && (
        <Button
          type="primary"
          onClick={onSend}
        >
          Enviar
        </Button>
      )}
    </Col>
  );
}

BenefitOrderButtons.propTypes = {
  onSave: PropTypes.func.isRequired,
  onDownloadDetailReport: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  onApplyValuesToAll: PropTypes.func.isRequired,
  onRequestReopening: PropTypes.func.isRequired,
  benefitOrder: PropTypes.shape().isRequired,
};

BenefitOrderButtons.defaultProps = {};

export default BenefitOrderButtons;
